export default [{
    title: "Palletizado",
    fontIcon: "pallet",
    resource: "Palletizado",
    action: "ver-palletizado",
    children: [{
        title: "Dashboard",
        icon: "LayoutIcon",
        resource: "Palletizado",
        action: "ver-palletizado-dashboard",
    }, {
        title: "Configuracion",
        icon: "SettingsIcon",
        resource: "Palletizado",
        action: "ver-palletizado-configuracion",
    }, {
        title: "Mantenimiento",
        icon: "EditIcon",
        resource: "Palletizado",
        action: "ver-palletizado-mantenimiento",
        children: [{
                route: "palletizado-generar-etiqueta",
                title: "Imprimir Etiqueta",
                resource: "Palletizado",
                action: "ver-palletizado-generar-etiqueta",
            },
            {
                route: "palletizado-reversar-etiqueta",
                title: "Reservación de Etiquetas",
                resource: "Palletizado",
                action: "ver-palletizado-reversar-etiqueta",
            },
        ]
    }, {
        title: "Transacciones",
        fontIcon: "exchange-alt",
        resource: "Palletizado",
        action: "ver-palletizado-transacciones",
        children: [{
                route: "palletizado-aprobar-pallet",
                title: "Aprobar pallet",
                resource: "Palletizado",
                action: "ver-palletizado-aprobar-pallet",
            },
        ]
    }, {
        title: "Informes",
        fontIcon: "file-prescription",
        resource: "Palletizado",
        action: "ver-palletizado-informes",
        children: [{
                route: "palletizado-stock",
                title: "Layout Camara",
                resource: "Palletizado",
                action: "ver-palletizado-stock-pallet",
            },
            {
                route: "palletizado-movimiento",
                title: "Movimiento en Camaras",
                resource: "Palletizado",
                action: "ver-palletizado-reporte-movimientos",
            }
        ]
    }, ]
}]